// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartFulfillmentMethodStyles } from "@awc/Overrides/Widgets/Cart/CartFulfillmentMethodSelector";
import { styledBoxStyle } from "@awc/XDL/Components/Common/Box";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";


cartFulfillmentMethodStyles.container = {
    css: css`
        ${styledBoxStyle}
        margin-bottom: 24px;
    `,
};

cartFulfillmentMethodStyles.fulfillmentMethodradioGroup = {
    ...{ horizontal: true },
    css: css`
            display: inline-block;
            & > ${TypographyStyle} {
                font-size: ${fontConfig.fontSize.link}px;
                line-height: ${fontConfig.lineHeight.regular};
                font-weight: ${fontConfig.weight.bold};
                color: ${color("primary.main")};
                margin-bottom: 19px;
            }
        `,
};
cartFulfillmentMethodStyles.fulfillmentMethodRadio = {
    css: css`
        label {
            font-weight: ${fontConfig.weight.bold};
            color: ${color("text")};
            font-size: ${fontConfig.fontSize.singleLineRegular}px;
            line-height: ${fontConfig.lineHeight.singleLineRegular};
        }
    `,
};

cartFulfillmentMethodStyles.sectionWrapper = {
    css: css`
        display: flex;
        column-gap:48px;
        row-gap: 22px;
        flex-wrap: wrap;
        & > div {
            margin-top: 0;
        }
    `,
};
cartFulfillmentMethodStyles.pickUpLocation = {
    wrapper: {
        css: css`
            margin: 0;
        `,
    },
    headerText: {
        size: fontConfig.fontSize.link,
        lineHeight: fontConfig.lineHeight.regular,
        weight: fontConfig.weight.bold,
        color: "primary.main",
        css: css` 
            margin-bottom: 19px;
            display: block;
        `,
    },
};